import request from '@/utils/request'

// 查看用户详细信息
export function getUserDetails(params) {
  return request({
    url: '/user/userInfo',
    method: 'get',
    params
  })
}
//用户列表
export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params
  })
}
//获取用户下拉列表
export function getSelectUserList(params) {
  return request({
    url: '/user/selectUser/list',
    method: 'get',
    params
  })
}
//修改用户个人信息
export function updateUserInfo(data) {
  return request({
    url: '/user/update/userInfo',
    method: 'post',
    data
  })
}

//修改用户个人信息
export function updateUserStatus(data) {
  return request({
    url: '/user/updateUser',
    method: 'get',
    params: data
  })
}


//添加新用户
export function addUser(data) {
  return request({
    url: '/sys/register',
    method: 'post',
    data
  })
}

//修改手机号
export function modifyPhoneApi(data) {
  return request({
    url: '/user/current/modifyPhone',
    method: 'post',
    data
  })
}

//修改密码
export function modifyPasswordApi(data) {
  return request({
    url: '/user/editPwd',
    method: 'post',
    data
  })
}

//忘记密码
export function forgetPasswordApi(data) {
  return request({
    url: '/user/forgetPassword',
    method: 'post',
    data
  })
}

